/* eslint-disable react/prop-types */
import React from 'react';
import CustomerDetail from '@components/customer/CustomerDetail';

function CustomerDetailScreen(props) {
  return <CustomerDetail {...props} />;
}

export default CustomerDetailScreen;
